 <link defer="" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/7.0.1/css/all.min.css" rel="stylesheet">
<div class="footerSection">
  <div class="footerContentWrapper">
    <div class="cscLogoSection">
      <div class="cscImage">
        <img loading="lazy" src="../../../assets/img/CSC-Footer-logo.png" alt="CSC Logo" />
      </div>
    </div>
    <div class="addressSection">
      <div class="contactinfoSection">
        <p>818.885.5150</p>
       <p><a href="mailto:info@csc-usa.com">info@csc-usa.com</a></p>
        <p>17101 Superior Street</p>
        <p>Northridge</p>
        <p>CA 91325</p>
      </div>
    </div>
    <div class="linksSection">
      <mat-list-item [routerLink]="['/home']"><p>Home</p></mat-list-item>
      <mat-list-item [routerLink]="['/team']"><p>Team</p></mat-list-item>
      <mat-list-item [routerLink]="['/services']" ><p>Services</p></mat-list-item>
      <mat-list-item [routerLink]="['/state-labor-laws']"><p>Labor Laws</p></mat-list-item>
      <mat-list-item [routerLink]="['/privacy-policy']"><p>Privacy</p></mat-list-item>
      <!-- <mat-list-item><p></p>Get Started</mat-list-item> -->
    </div>

    <!-- <div class="newsletterSection">
      <div *ngIf="!isSubmitted && !successfulRegistration">
        <button
          mat-raised-button
          class="cscGoldBtn"
          (click)="newsletterSignUp()"
        >
          Newsletter Sign Up
        </button>
      </div>
      <ng-container *ngIf="isSubmitted">
        <div>
          <p class="registering">Registering</p>
          <app-loading-spinner></app-loading-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="successfulRegistration">
        <div class="successMsg">
          {{ successMessage }}
        </div>
      </ng-container>
    </div> -->

    <div class="socialMediaSection">
      <p>Follow Us</p>
      <div class="socialIcons">
        <a aria-label="facebook" href="https://www.facebook.com/CSC.CrowdMgmt" target="_blank" rel="noopener noreferrer"><i class="fab fa-facebook"> </i>
        </a>

   <!--Instagram-->
   <a aria-label="instagram" href="https://www.instagram.com/goteamcsc/" target="_blank" rel="noopener noreferrer"><i class="fab fa-instagram-square"> </i></a>
   <!--LinkedIn-->
   <a aria-label="linkedin" href="https://www.linkedin.com/company/856712/" target="_blank" rel="noopener noreferrer"><i class="fab fa-linkedin"> </i></a>
      </div>
    </div>
  </div>
</div>
